<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xl3 lg4 md5 sm6>
        <v-layout row wrap>
          <v-flex>
            <v-card class="elevation-12">
              <v-layout>
                <v-flex class="ma-4">
                  <h1 color="white">
                    {{ $t("modules.sessionExpired.message") }}
                  </h1>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "SessionExpiredPage",
  created: function() {
    setTimeout(() => {
      this.$router.push({ path: "/login" });
    }, 5000);
  }
};
</script>
